import { keyframes, style } from '@vanilla-extract/css';
import { themeVars } from '../themeVars.css';

const slideInRightAnimation = keyframes({
  from: {
    opacity: 0,
    transform: 'translate3d(2%, 0, 0)',
  },

  to: {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
  },
});

const slideOutLeftAnimation = keyframes({
  from: {
    opacity: 1,
  },

  to: {
    opacity: 0,
    transform: 'translate3d(-2%, 0, 0)',
  },
});

const slideInLeftAnimation = keyframes({
  from: {
    opacity: 0,
    transform: 'translate3d(-2%, 0, 0)',
  },

  to: {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
  },
});

const slideOutRightAnimation = keyframes({
  from: {
    opacity: 1,
  },
  to: {
    opacity: 0,
    transform: ' translate3d(2%, 0, 0)',
  },
});

export const slideOutRight = style({
  animationName: slideOutRightAnimation,
});

export const slideInRight = style({
  animationName: slideInRightAnimation,
});
export const slideInLeft = style({
  animationName: slideInLeftAnimation,
});
export const slideOutLeft = style({
  animationName: slideOutLeftAnimation,
});
export const animated = style({
  animationDuration: themeVars.durations.default,
  animationFillMode: 'both',
});

export const animatedIn = style({
  animationDuration: '250ms',
  animationFillMode: 'both',
});

export const animatedOut = style({
  animationDuration: '600ms',
  animationFillMode: 'both',
});

export const shimmerAnimation = keyframes({
  '100%': {
    transform: 'translateX(100%)',
  },
});

const rotateAnimation = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

export const spin = style({
  willChange: 'transform',
  animationName: rotateAnimation,
  animationDuration: '1.3s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});

const shineAnimation = keyframes({
  '0%': { backgroundPosition: '-100% 0' },
  '100%': { backgroundPosition: '100% 0' },
});

export const shine = style({
  willChange: 'transform',
  animationName: shineAnimation,
  animationDuration: '2s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});

const fadeInAnimation = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 },
});

export const fadeIn = style({
  willChange: 'opacity',
  animationName: fadeInAnimation,
  animationDuration: '0.2s',
  animationTimingFunction: 'linear',
});

const shakeAnimation = keyframes({
  '0%': { transform: 'translateX(0)' },
  '25%': { transform: 'translateX(5px)' },
  '50%': { transform: 'translateX(-5px)' },
  '75%': { transform: 'translateX(5px)' },
  '100%': { transform: 'translateX(0)' },
});

export const shake = style({
  animationName: shakeAnimation,
  animationDuration: '0.3s',
  animationTimingFunction: 'linear',
  willChange: 'transform',
  animationIterationCount: 'infinite',
});
